
$( document ).ready(function() {
    $('.modal').on('shown.bs.modal', function () {
        $(this).find('video')[0].play();
      })
      $('.modal').on('hidden.bs.modal', function () {
        $(this).find('video')[0].pause();
    }) 
});
